export default { sha: '96708426c35ba36267ba651503a27627eaf73bde', buildNumber: 'undefined' }
